// How a loan pays off from where it is now: each EMI first pays the interest on what's
// left (the yearly rate spread over the EMI's frequency, monthly when it doesn't say),
// the rest comes off the loan. The server does the same when an EMI is marked paid.
export const periodRate = (loan) => {
  const yearly = (loan.interestRate || 0) / 100;
  const every = loan.repeatEvery || 1;
  if (loan.repeatUnit === "days") return (yearly / 365) * every;
  if (loan.repeatUnit === "years") return yearly * every;
  return (yearly / 12) * every;
};

// { emisLeft, interestLeft } from today's remaining amount, or { neverEnds: true } when
// the EMI doesn't even cover the interest. Null when there's nothing to work out.
export const loanPayoff = (loan) => {
  const left = loan.remainingBalance;
  const emi = loan.monthlyPayment;
  if (!(left > 0) || !(emi > 0)) return null;
  const r = periodRate(loan);
  if (r === 0) return { emisLeft: Math.ceil(left / emi), interestLeft: 0 };
  if (emi <= left * r) return { neverEnds: true, interestPerEmi: left * r };
  const n = Math.ceil(-Math.log(1 - (r * left) / emi) / Math.log(1 + r));
  return { emisLeft: n, interestLeft: Math.max(0, n * emi - left) };
};

// "about 42 EMIs left · ₹1,02,300 interest to go"
export const payoffText = (loan, money) => {
  const p = loanPayoff(loan);
  if (!p) return "";
  if (p.neverEnds) return `EMI doesn't cover the ${money(Math.round(p.interestPerEmi))} interest`;
  const emis = `about ${p.emisLeft} EMI${p.emisLeft === 1 ? "" : "s"} left`;
  return p.interestLeft > 0 ? `${emis} · ${money(Math.round(p.interestLeft))} interest to go` : emis;
};
